import { render, staticRenderFns } from "./configgrp.vue?vue&type=template&id=2337df92&scoped=true&"
import script from "./configgrp.vue?vue&type=script&lang=js&"
export * from "./configgrp.vue?vue&type=script&lang=js&"
import style0 from "./configgrp.vue?vue&type=style&index=0&id=2337df92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337df92",
  null
  
)

export default component.exports